var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M4 7a3 3 0 100-6 3 3 0 000 6z","stroke":"#36C89B","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }